var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "intro" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "introbox" }, [
        _c("ul", { staticClass: "ibnav" }, [
          _c("li", { class: { active: _vm.tab == 0 } }, [
            _c("em"),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("a", {
              staticClass: "wlink",
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.tab = 0
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("li", { class: { active: _vm.tab == 1 } }, [
            _c("em"),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("a", {
              staticClass: "wlink",
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.tab = 1
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("li", { class: { active: _vm.tab == 2 } }, [
            _c("em"),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("a", {
              staticClass: "wlink",
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.tab = 2
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "ibitems" }, [
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tab == 0,
                  expression: "tab==0"
                }
              ]
            },
            [
              _c("img", { attrs: { src: "temp/tab2.jpg" } }),
              _vm._v(" "),
              _c("div", { staticClass: "over" }, [
                _c(
                  "div",
                  { staticClass: "join" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "jbtn",
                        attrs: { to: { name: "packages" } }
                      },
                      [_vm._v("Join Now!")]
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tab == 1,
                  expression: "tab==1"
                }
              ]
            },
            [
              _c("img", { attrs: { src: "temp/tab1.jpg" } }),
              _vm._v(" "),
              _c("div", { staticClass: "over" }, [
                _c(
                  "div",
                  { staticClass: "join" },
                  [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "jbtn",
                        attrs: { to: { name: "packages" } }
                      },
                      [_vm._v("Join Now!")]
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tab == 2,
                  expression: "tab==2"
                }
              ]
            },
            [
              _c("img", { attrs: { src: "temp/tab3.jpg" } }),
              _vm._v(" "),
              _c("div", { staticClass: "over" }, [
                _c(
                  "div",
                  { staticClass: "join" },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "jbtn",
                        attrs: { to: { name: "packages" } }
                      },
                      [_vm._v("Join Now!")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibnin" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Pay per Video")]),
      _vm._v(" "),
      _c("span", { staticClass: "subtitle" }, [
        _vm._v("Watch videos individually and pay only for what you use.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibnin" }, [
      _c("span", { staticClass: "title" }, [_vm._v("PAY PER GROUP OF VIDEOS")]),
      _vm._v(" "),
      _c("span", { staticClass: "subtitle" }, [
        _vm._v("Watch entire groups of videos with Kathi's monthly packages.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibnin" }, [
      _c("span", { staticClass: "title" }, [_vm._v("PPATT TRAINING VIDEOS")]),
      _vm._v(" "),
      _c("span", { staticClass: "subtitle" }, [
        _vm._v("As a PPATT student, review your training sessions exclusively.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "jprice" }, [
      _c("span", { staticClass: "stf" }, [_vm._v("starting from")]),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n                  $29"),
        _c("sup", [_vm._v(",00")]),
        _vm._v(" "),
        _c("span", [_vm._v("/mo")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "jprice" }, [
      _c("span", { staticClass: "stf" }, [_vm._v("starting from")]),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n                  $29"),
        _c("sup", [_vm._v(",00")]),
        _vm._v(" "),
        _c("span", [_vm._v("/mo")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "jprice" }, [
      _c("span", { staticClass: "stf" }, [_vm._v("starting from")]),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n                  $29"),
        _c("sup", [_vm._v(",00")]),
        _vm._v(" "),
        _c("span", [_vm._v("/mo")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }